var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 5,
  viewBox: "0 0 7 5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "01-\\u767B\\u5165\\u9801",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "01-1-\\u767B\\u5165\\u9801",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(-1851 -61)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-point-to-right",
  transform: "rotate(90 898.25 959.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M3.856 3.847.84 6.857a.49.49 0 0 1-.695 0 .49.49 0 0 1 0-.694L2.814 3.5.144.837a.49.49 0 0 1 0-.693.49.49 0 0 1 .695 0l3.017 3.01a.49.49 0 0 1 0 .693"
}))))));
export default SvgArrowDown;